import { BsLinkedin, BsGithub, BsWhatsapp } from "react-icons/bs";

const HeaderSocials = () => {
  return (
    <div className="header_socials">
      <a href="https://www.linkedin.com/in/amir-ebrahimi1-/" target="_blank">
        <BsLinkedin />
      </a>
      <a href="https://github.com/amir-h-e" target="_blank">
        <BsGithub />
      </a>
      <a
        href="https://api.whatsapp.com/send?phone=989017616117"
        target="_blank"
      >
        <BsWhatsapp />
      </a>
    </div>
  );
};

export default HeaderSocials;
